<dialog
  #modal
  qai-dialog
  [heading]="modalHeadingKey() | transloco"
  [description]="modalDescriptionKey() | transloco"
  (afterClose)="handleClose()"
>
  <!-- Edit step -->
  @if (step() === 'edit') {
    <qai-field [label]="'simulationBuilder.CONVERSE_PROMPT_FIELD_LABEL' | transloco">
      <textarea
        qai-textarea
        autosize
        [maxLines]="20"
        qaiPasteClean
        qaiTrimLeading
        [ngModel]="editedText()"
        (ngModelChange)="editedText.set($event)"
      ></textarea>
    </qai-field>
  }

  @if (isRefinementInProgress()) {
    <p class="refinement-warning">{{ 'simulationBuilder.REFINEMENT_IN_PROGRESS_OVERRIDE_WARNING' | transloco }}</p>
  }

  <div class="modal-actions">
    <button qai-button kind="secondary" size="medium" (click)="handleCancel()">
      {{ 'simulationBuilder.BUTTON_CANCEL' | transloco }}
    </button>
    @if (step() === 'edit') {
      <button
        qai-button
        kind="primary"
        size="medium"
        [disabled]="!editedText().trim() || isRefinementInProgress()"
        (click)="handleSave()"
      >
        {{ 'simulationBuilder.CONVERSE_PROMPT_SAVE_BUTTON' | transloco }}
      </button>
    }
    @if (step() === 'confirm') {
      <button
        qai-button
        kind="primary"
        size="medium"
        [disabled]="isLoading() || isRefinementInProgress()"
        (click)="handleConfirm()"
      >
        {{ 'simulationBuilder.BUTTON_CONFIRM' | transloco }}
      </button>
    }
  </div>
</dialog>
